import partAlerts from './modules/part-alerts';
import search from './pages/search';

partAlerts();
search();